var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 6 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-form-item",
            { attrs: { label: "新密码" } },
            [
              _c("a-input-password", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["newPassword", _vm.rules.newPassword],
                    expression: "['newPassword', rules.newPassword]",
                  },
                ],
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            { attrs: { label: "确认密码" } },
            [
              _c("a-input-password", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["passwordSec", _vm.rules.passwordSec],
                    expression: "['passwordSec',rules.passwordSec]",
                  },
                ],
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }